import {
  ActionIcon,
  Box,
  Card,
  Group,
  Image,
  Stack,
  Text,
  Tooltip,
} from "@mantine/core";
import { IconEdit, IconGripVertical, IconTrash } from "@tabler/icons-react";
import { Link } from "react-router-dom";

const LOGO_SIZE = 56;

function SponsorCard({ sponsor, reps, dragHandleProps, isDragging, onDelete }) {
  return (
    <Card
      withBorder
      shadow={isDragging ? "lg" : "xs"}
      radius="md"
      p="sm"
      style={{
        backgroundColor: isDragging ? "var(--mantine-color-blue-0)" : undefined,
      }}
    >
      <Group wrap="nowrap" align="center" gap="sm">
        <Box
          {...dragHandleProps}
          style={{
            cursor: "grab",
            color: "var(--mantine-color-gray-5)",
            display: "flex",
            alignItems: "center",
          }}
        >
          <IconGripVertical size={20} />
        </Box>

        <Box w={LOGO_SIZE} h={LOGO_SIZE} style={{ flexShrink: 0 }}>
          {sponsor.logo ? (
            <Image
              src={sponsor.logo}
              h={LOGO_SIZE}
              w={LOGO_SIZE}
              fit="contain"
              radius="sm"
            />
          ) : (
            <Box
              w={LOGO_SIZE}
              h={LOGO_SIZE}
              style={{
                border: "1px dashed var(--mantine-color-gray-4)",
                borderRadius: 6,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Text size="xs" c="dimmed">
                No logo
              </Text>
            </Box>
          )}
        </Box>

        <Stack gap={2} style={{ flex: 1, minWidth: 0 }}>
          <Text fw={600} size="sm" lineClamp={1}>
            {sponsor.name || "Untitled sponsor"}
          </Text>
          {sponsor.description && (
            <Text size="xs" c="dimmed" lineClamp={2}>
              {sponsor.description}
            </Text>
          )}

          {reps?.length > 0 && (
            <Group gap={6} wrap="wrap" mt={2}>
              {reps.map((rep) => (
                <Text key={rep.id} size="xs" c="gray.7">
                  {rep.firstName} {rep.lastName}
                  {rep.occupation ? ` · ${rep.occupation}` : ""}
                </Text>
              ))}
            </Group>
          )}
        </Stack>

        <Group gap="xs" wrap="nowrap">
          <Tooltip label="Edit">
            <ActionIcon
              component={Link}
              to={`${sponsor.id}`}
              variant="light"
              color="blue"
              size="md"
            >
              <IconEdit size={20} />
            </ActionIcon>
          </Tooltip>
          <Tooltip
            label={
              sponsor.isInGiveaway
                ? "Cannot delete — sponsor is part of a giveaway"
                : "Delete"
            }
          >
            <ActionIcon
              variant="light"
              color="red"
              size="md"
              onClick={onDelete}
              disabled={sponsor.isInGiveaway}
            >
              <IconTrash size={20} />
            </ActionIcon>
          </Tooltip>
        </Group>
      </Group>
    </Card>
  );
}

export default SponsorCard;
